import React, { useState, useEffect } from 'react'
import { useMyContext } from '../../../components/Provider/CommonProvider'
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading'
import { toast } from 'react-toastify'
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif'

// Logos
import stripe_image from "../../../components/Images/payment_logo/stripe.svg";
import paypal_image from "../../../components/Images/payment_logo/paypal.svg";
import razorpay_image from "../../../components/Images/payment_logo/razorpay.svg";
import iyzico_image from "../../../components/Images/payment_logo/iyzico.svg";
import pesapal_image from "../../../components/Images/payment_logo/pesapal.svg";
import PayHere_image from "../../../components/Images/payment_logo/PayHere.svg";
import cashfree_image from "../../../components/Images/payment_logo/cashfree.svg"
import googlepay_image from "../../../components/Images/payment_logo/googlepay.svg"
import applepay_image from "../../../components/Images/payment_logo/applepay.svg"
import ideabiz_image from "../../../components/Images/payment_logo/ideabiz.png"
import paystack_image from "../../../components/Images/payment_logo/paystack.svg"
import donorbox_image from "../../../components/Images/payment_logo/donorbox.svg"

import "./PaymentSettings.css";

const PaymentGatewaysSettings = () => {
    const baseUrl = process.env.REACT_APP_Baseurl
    const indexApi = `${baseUrl}/admin/payment-settings/index`
    const storeApi = `${baseUrl}/api/initial-payment-store`

    const { fetchRequest } = useMyContext()

    const [formData, setFormData] = useState({})
    const [loading, setLoading] = useState(true)

    const logoMapping = {
        stripe: stripe_image,
        paypal: paypal_image,
        razorpay: razorpay_image,
        iyzico: iyzico_image,
        pesapal: pesapal_image,
        payhere: PayHere_image,
        cashfree: cashfree_image,
        googlepay: googlepay_image,
        applepay: applepay_image,
        ideabiz: ideabiz_image,
        paystack: paystack_image,
        donorbox: donorbox_image
    }

    const handleInput = (e) => {
        const { name, checked } = e.target

        setFormData(prev => ({
            ...prev,
            [name]: checked ? 1 : 0
        }))
    }

    const fetchData = async () => {
        try {
            setLoading(true)
            const data = await fetchRequest({ method: 'GET', url: indexApi })

            if (data?.status) {
                setFormData(data?.data)
            }
        } catch (error) {
            toast.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleUpdate = async () => {
        try {
            setLoading(true)
            const payload = Object.fromEntries(
                Object.entries(formData).map(([k, v]) => [
                    k[0].toUpperCase() + k.slice(1),
                    { status: v }
                ])
            );
            const result = await fetchRequest({ method: 'POST', url: storeApi, data: payload })

            if (result?.status) {
                toast.success("Payment Gateways status updated successfully")
            }
        } catch (error) {
            toast.error(error?.message)
        } finally {
            setLoading(false)
        }
    }

    const entries = Object.entries(formData || {})
    const half = Math.ceil(entries.length / 2)

    const leftData = entries.slice(0, half)
    const rightData = entries.slice(half)

    useEffect(() => {
        fetchData()
    }, [])

    if (loading) return <Defaultloadinggif className="heightOnLoader" />

    const renderGatewayRow = ([key, value]) => {
        const logo = logoMapping[key.toLowerCase()]
        const displayName = key.replace(/_/g, " ").toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        return (
            <div className="d-flex align-items-center justify-content-between mb-4 shadow p-3 rounded-4 flex-wrap" key={key}>
                <div className="col-12 col-lg-2 text-start d-flex align-items-center">
                    {logo ? (
                        <img src={logo} alt={key} className="payment-image" />
                    ) : (
                        <div className="payment-image d-flex align-items-center justify-content-center bg-light rounded text-muted" style={{ fontSize: '10px' }}>
                            NO LOGO
                        </div>
                    )}
                </div>
                <div className="col-12 col-lg-7 ps-lg-4">
                    <MessageLabel text={displayName} noMargin className="mb-1" />
                    <MessageSubHeading text={`Enable or disable ${displayName} for users.`} noMargin />
                </div>
                <div className='col-12 col-lg-3 d-flex justify-content-end align-items-center'>
                    <AdminSwitch name={key} checked={Boolean(value)} onChange={handleInput} />
                </div>
            </div>
        )
    }



    return (
        <>
            <AdminSaveHeader heading={'Payment Gateways'} saveText={'Update'} saveMethod={handleUpdate} loading={loading} />
            
            <section className="theme-bg-color rounded-3 p-lg-4 p-3">
                <MessageHeading text={"GATEWAY VISIBILITY SETTINGS"} className="mb-5" noMargin />
                
                <FormContainer>
                    <LeftWrapper>
                        <Wrapper>
                            {leftData.map(renderGatewayRow)}
                        </Wrapper>
                    </LeftWrapper>

                    <RightWrapper>
                        <Wrapper>
                            {rightData.map(renderGatewayRow)}
                        </Wrapper>
                    </RightWrapper>
                </FormContainer>
            </section>
        </>
    )
}

export default PaymentGatewaysSettings